import { Subscription, Subject } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService } from './core/_base/layout';
// Layout
import { TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { LoaderService } from './core/_base/layout/services/loader.service';
import { AuthService } from './core/auth/_services/auth.service';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	myHour = new Date();
	// Public properties
	title = 'Debtor Education';
	loader: boolean;
	// loading: boolean = true;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	loading: Subject<boolean> = this.loaderService.loading;
	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(private translationService: TranslationService,
				private router: Router,
				private layoutConfigService: LayoutConfigService,
				private splashScreenService: SplashScreenService,
				public authService:AuthService,
				public loaderService: LoaderService) {
		// register translations
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// set page progress bar loading to end on NavigationEnd event router
				// this.loading = false;
			}
		});
	}
	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const time = this.myHour.getHours() + 1; //one hour from now		
		localStorage.setItem('time', JSON.stringify(time));
		var myinterval = 15*60*1000; 
		setInterval(() => {  this.checkExpiration(); }, myinterval );				
		this.loader = this.layoutConfigService.getConfig('loader.enabled');
		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {				
				this.splashScreenService.hide();				
				window.scrollTo(0, 0);
			}
		});
		this.unsubscribe.push(routerSubscription);
	}
	checkExpiration () { 		
		const values = JSON.parse(localStorage.getItem('time'));					
		if (values < new Date().getHours()) {
			localStorage.removeItem("time");
			// this.authService.logout();
		}
	}
	// doBeforeUnload() {
	// 	// Alert the user window is closing 
	// 	return false;
	// }
	
	// doUnload() {
	// 	// Clear session or do something
	// 	this.authService.logout();
	// }
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}